const DEFAULT_APP_BASE_URL = "http://localhost:8080";

function normalizeBaseUrl(value: unknown): string | null {
  const base = String(value ?? "").trim();
  if (!base) return null;
  return base.replace(/\/+$/, "");
}

export function getAppBaseUrl(): string {
  return (
    normalizeBaseUrl(import.meta.env.VITE_APP_BASE_URL) ??
    normalizeBaseUrl(import.meta.env.VITE_PUBLIC_APP_URL) ??
    normalizeBaseUrl(window.location.origin) ??
    DEFAULT_APP_BASE_URL
  );
}

export function getPasswordResetRedirectUrl(): string {
  return `${getAppBaseUrl()}/reset-password`;
}
